import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import {
  Avatar,
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import {
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';

import MechanicIcon from '../../../assets/img/assistance/circle_mechanic_icon.svg';
// import MechanicIcon from '../../../assets/img/ic_mechanic_assistance.png';
import TrailerIcon from '../../../assets/img/assistance/circle_trailer_icon.svg';
// import TrailerIcon from '../../../assets/img/ic_trailer.png';
import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import SuraCard from '../../../components/SuraCard';
import {
  ASSISTANCE_STATUS_ACCEPTED,
  ASSISTANCE_STATUS_ON_ROAD,
  ASSISTANCE_STATUS_PENDING,
} from '../../../constants/assistance.constant';
import {
  ASSISTANCES_QUERY,
  ASSISTANCES_QUERY_CONFIG,
  assistancesQuery,
} from '../../../query/assistances/assistances';

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.secondary.main,
  },
  root: {
    background:
      'linear-gradient(79.82deg, #0033A0 0%, rgba(0, 51, 160, 0.7) 100%)',
  },
  container: {
    position: 'relative',
    maxWidth: '100%',
    margin: 'auto',
  },
  buttonNext: {
    background: 'transparent',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    position: 'absolute',
    top: '50%',
    right: '-22px',
    transform: 'translateY(-50%)',
    padding: '2px',
  },
}));

const AssistanceCard = (assistance: any) => {
  const { status, towing, id, trailer } = assistance;
  const classes = useStyles();

  return (
    <Box m={1}>
      <ButtonBase
        style={{ width: '100%' }}
        component={Link}
        to={'/assistance/' + id}
      >
        <SuraCard>
          <Box
            m={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="center">
              <Avatar
                className={classes.avatar}
                src={towing ? TrailerIcon : MechanicIcon}
                alt="Notificacion"
              />
              <Box ml={2}>
                <Typography>
                  {status === ASSISTANCE_STATUS_ON_ROAD
                    ? towing
                      ? 'Grúa en camino'
                      : 'Asistencia en camino'
                    : 'Pedido de asistencia'}
                </Typography>
                <Typography variant="caption">
                  {status === ASSISTANCE_STATUS_ON_ROAD
                    ? trailer?.estimated_time
                      ? `Llegada aproximada ${trailer?.estimated_time}`
                      : 'La ayuda llegará pronto'
                    : towing
                    ? 'Estamos buscando la grúa'
                    : 'Preparando la asistencia'}
                </Typography>
                <Typography color="secondary" variant="subtitle2">
                  Patente: {assistance.vehicle.license_plate}
                </Typography>
              </Box>
            </Box>
          </Box>
        </SuraCard>
      </ButtonBase>
    </Box>
  );
};

const AssistancesBanner = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const { data: assistances } = useQuery(
    ASSISTANCES_QUERY,
    assistancesQuery,
    ASSISTANCES_QUERY_CONFIG
  );

  const assistanceToShow = assistances
    ? assistances.filter(
        (a: any) =>
          a?.status === ASSISTANCE_STATUS_PENDING ||
          a?.status === ASSISTANCE_STATUS_ACCEPTED ||
          a?.status === ASSISTANCE_STATUS_ON_ROAD
      )
    : [];

  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <Box m={1} mt={2}>
          {assistanceToShow?.length > 2 ? (
            <CarouselProvider
              naturalSlideWidth={80}
              naturalSlideHeight={500}
              totalSlides={assistanceToShow.length}
              isIntrinsicHeight
              visibleSlides={matches ? 1 : 2}
              infinite
              isPlaying
              interval={5000}
            >
              <div className={classes.container}>
                <Slider>
                  {assistanceToShow?.map((assistance: any, index: number) => (
                    <Slide key={index} index={index}>
                      <AssistanceCard {...assistance}></AssistanceCard>
                    </Slide>
                  ))}
                </Slider>
                <ButtonNext className={classes.buttonNext}>
                  <RightIcon />
                </ButtonNext>
              </div>
            </CarouselProvider>
          ) : (
            <Grid container>
              {assistanceToShow?.map((assistance: any, index: number) => (
                <Grid key={index} xs={12} md={6} item>
                  <AssistanceCard {...assistance}></AssistanceCard>
                </Grid>
              )) || null}
            </Grid>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default AssistancesBanner;
